interface PropTypes {
  width: string;
  height?: string;
}

/*
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
      */

export function IconReacthookform(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M10.775 17.348H5.806a.281.281 0 100 .563h4.97a.281.281 0 100-.563zm7.32 0h-4.969a.281.281 0 100 .563h4.969a.281.281 0 000-.563zm-7.334-6.475H5.807a.281.281 0 100 .563h4.954a.281.281 0 100-.563zm7.32 0h-4.955a.281.281 0 100 .563h4.955a.281.281 0 000-.563zm.552-9.2h-4.341a2.404 2.404 0 00-4.58 0H5.366a3.097 3.097 0 00-3.096 3.096v16.134A3.097 3.097 0 005.367 24h13.266a3.097 3.097 0 003.096-3.097V4.77a3.097 3.097 0 00-3.096-3.096zm-8.705.563a.281.281 0 00.281-.223 1.841 1.841 0 013.598 0 .281.281 0 00.282.223h1.514V4.08a.845.845 0 01-.844.844H9.255a.845.845 0 01-.844-.844V2.236zm11.238 18.667c0 1.4-1.134 2.534-2.533 2.534H5.367a2.534 2.534 0 01-2.533-2.534V4.77c0-1.399 1.134-2.533 2.533-2.533h2.48V4.08c0 .777.63 1.407 1.408 1.407h5.49c.777 0 1.407-.63 1.407-1.407V2.236h2.48c1.4 0 2.534 1.134 2.534 2.533z" />
    </svg>
  );
}

export function IconStyledcomponents(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M16.214 6.762l-.075.391c-.116.741-.074.953.244 1.228l.307.254-.318 1.418c-.19.846-.423 1.555-.571 1.788-.127.201-.275.497-.307.656-.053.19-.233.381-.508.55-.243.138-.72.508-1.058.805-.27.243-.456.392-.557.456l-.33.261a1.4 1.4 0 00-.189.411c-.023.107-.01.178.024.23.033.05.09.085.168.107a.954.954 0 00.282.023 3 3 0 00.632-.112c.07-.019.125-.037.173-.053.074-.091.245-.263.548-.562.804-.793 1.111-1.227.794-1.11-.117.042-.064-.064.137-.276.424-.413.667-1.037 1.175-2.994.402-1.545.402-1.567.698-1.567.139 0 .532.024.532.024V6.762h-.902zm3.839 3.165c-.064 0-.17.096-.233.202-.116.19.021.306 1.767 1.396 1.037.657 1.873 1.217 1.852 1.26-.021.031-.868.582-1.883 1.217-1.842 1.142-1.852 1.153-1.683 1.386.212.275 0 .37 2.391-1.122L24 13.155v-.836l-1.937-1.196c-1.047-.656-1.957-1.185-2.01-1.196zm-16.085.117c-.053 0-.963.54-2.01 1.185L0 12.425v.836l1.947 1.217c1.08.666 1.99 1.217 2.032 1.217.042 0 .127-.096.212-.212.127-.201.02-.286-1.768-1.418C.72 12.996.54 12.848.71 12.732c.106-.074.91-.572 1.778-1.111 1.979-1.217 1.873-1.133 1.714-1.387-.063-.105-.17-.2-.233-.19zm8.684.023c-.292-.002-.92.443-2.8 1.978-.081.193-.088.326-.051.412.024.059.068.1.129.13.06.03.138.048.224.055.171.015.373-.012.536-.044l.11-.025a.386.386 0 01.144-.118c.116-.064.603-.508 1.09-.984.857-.868 1.058-1.26.709-1.387a.24.24 0 00-.09-.017zm2.196.603c-.257.007-.72.305-1.513.938-.398.323-.65.497-.785.533l-.524.414c-.197.36-.226.583-.174.706a.25.25 0 00.138.134.644.644 0 00.24.045 2.18 2.18 0 00.58-.085 3.466 3.466 0 00.291-.092l.029-.012.053-.028c.1-.129.33-.372.618-.652.91-.878 1.375-1.502 1.28-1.735-.043-.113-.117-.17-.233-.166zm-2.424 1.08c-.074.008-.24.136-.539.398-.432.382-.903.602-1.066.504a3.97 3.97 0 01-.114.024c-.166.033-.373.06-.558.045a.708.708 0 01-.252-.063.337.337 0 01-.168-.17c-.037-.09-.037-.202.005-.345l-.65.534-1.471 1.217v1.973l4.82-3.797a.41.41 0 01.016-.123c.037-.134.035-.202-.023-.196zm2.074.639c-.073 0-.195.103-.39.31-.265.283-.682.557-.903.613l-.034.018a2.191 2.191 0 01-.11.042c-.06.02-.138.044-.228.068-.18.049-.404.094-.604.089a.732.732 0 01-.275-.054.344.344 0 01-.184-.18c-.058-.139-.035-.334.092-.611L7.61 16.033v1.205h1.868l3.962-3.112c.103-.114.258-.27.467-.465.56-.519.687-.698.687-.963 0-.206-.023-.31-.096-.31zm.943 1.95l-.339.338c-.19.18-.529.402-.761.497l-.046.02-.003.005-.01.01c-.009.007-.013.008-.02.011a3.432 3.432 0 01-.282.093 3.058 3.058 0 01-.65.115 1.035 1.035 0 01-.31-.027.364.364 0 01-.218-.144c-.048-.074-.062-.173-.035-.295a1.11 1.11 0 01.095-.25l-3.197 2.526h4.252l.508-.582c.698-.814 1.016-1.396 1.016-1.894z" />
    </svg>
  );
}

export function IconTailwind(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M12 6c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.31.74 1.91 1.35.98 1 2.09 2.15 4.59 2.15 2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.3-.74-1.91-1.35C15.61 7.15 14.5 6 12 6m-5 6c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.3.74 1.91 1.35C8.39 16.85 9.5 18 12 18c2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.3-.74-1.91-1.35C10.61 13.15 9.5 12 7 12z" />
    </svg>
  );
}

export function IconFramer(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M4 0h16v8h-8zm0 8h8l8 8H4zm0 8h8v8z" />
    </svg>
  );
}

export function IconNextjs(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path
        fillRule="evenodd"
        d="M0 7.5a7.5 7.5 0 1111.697 6.216L4.907 4.21A.5.5 0 004 4.5V12h1V6.06l5.83 8.162A7.5 7.5 0 010 7.5zM10 10V4h1v6h-1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function IconReactquery(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M6.93 13.688a.343.343 0 01.468.132l.063.106c.48.851.98 1.66 1.5 2.426a35.65 35.65 0 002.074 2.742.345.345 0 01-.039.484l-.074.066c-2.543 2.223-4.191 2.665-4.953 1.333-.746-1.305-.477-3.672.808-7.11a.344.344 0 01.153-.18zM17.75 16.3a.34.34 0 01.395.27l.02.1c.628 3.286.187 4.93-1.325 4.93-1.48 0-3.36-1.402-5.649-4.203a.327.327 0 01-.074-.222c0-.188.156-.34.344-.34h.121a32.984 32.984 0 002.809-.098c1.07-.086 2.191-.23 3.359-.437zm.871-6.977a.353.353 0 01.445-.21l.102.034c3.262 1.11 4.504 2.332 3.719 3.664-.766 1.305-2.993 2.254-6.684 2.848a.362.362 0 01-.238-.047.343.343 0 01-.125-.476l.062-.106a34.07 34.07 0 001.367-2.523c.477-.989.93-2.051 1.352-3.184zM7.797 8.34a.362.362 0 01.238.047.343.343 0 01.125.476l-.062.106a34.088 34.088 0 00-1.367 2.523c-.477.988-.93 2.051-1.352 3.184a.353.353 0 01-.445.21l-.102-.034C1.57 13.742.328 12.52 1.113 11.188 1.88 9.883 4.106 8.934 7.797 8.34zm5.281-3.984c2.543-2.223 4.192-2.664 4.953-1.332.746 1.304.477 3.671-.808 7.109a.344.344 0 01-.153.18.343.343 0 01-.468-.133l-.063-.106a34.64 34.64 0 00-1.5-2.426 35.65 35.65 0 00-2.074-2.742.345.345 0 01.039-.484zM7.285 2.274c1.48 0 3.364 1.402 5.649 4.203a.349.349 0 01.078.218.348.348 0 01-.348.344l-.117-.004a34.584 34.584 0 00-2.809.102 35.54 35.54 0 00-3.363.437.343.343 0 01-.394-.273l-.02-.098c-.629-3.285-.188-4.93 1.324-4.93zm2.871 5.812h3.688a.638.638 0 01.55.316l1.848 3.22a.644.644 0 010 .628l-1.847 3.223a.638.638 0 01-.551.316h-3.688a.627.627 0 01-.547-.316L7.758 12.25a.644.644 0 010-.629L9.61 8.402a.627.627 0 01.546-.316zm3.23.793a.638.638 0 01.552.316l1.39 2.426a.644.644 0 010 .629l-1.39 2.43a.638.638 0 01-.551.316h-2.774a.627.627 0 01-.546-.316l-1.395-2.43a.644.644 0 010-.629l1.395-2.426a.627.627 0 01.546-.316zm-.491.867h-1.79a.624.624 0 00-.546.316l-.899 1.56a.644.644 0 000 .628l.899 1.563a.632.632 0 00.547.316h1.789a.632.632 0 00.547-.316l.898-1.563a.644.644 0 000-.629l-.898-1.558a.624.624 0 00-.547-.317zm-.477.828c.227 0 .438.121.547.317l.422.73a.625.625 0 010 .629l-.422.734a.627.627 0 01-.547.317h-.836a.632.632 0 01-.547-.317l-.422-.734a.625.625 0 010-.629l.422-.73a.632.632 0 01.547-.317zm-.418.817a.548.548 0 00-.473.273.547.547 0 000 .547.544.544 0 00.473.27.544.544 0 00.473-.27.547.547 0 000-.547.548.548 0 00-.473-.273zm-4.422.546h.98M18.98 7.75c.391-1.895.477-3.344.223-4.398-.148-.63-.422-1.137-.84-1.508-.441-.39-1-.582-1.625-.582-1.035 0-2.12.472-3.281 1.367a14.9 14.9 0 00-1.473 1.316 1.206 1.206 0 00-.136-.144c-1.446-1.285-2.66-2.082-3.7-2.39-.617-.184-1.195-.2-1.722-.024-.559.187-1.004.574-1.317 1.117-.515.894-.652 2.074-.46 3.527.078.59.214 1.235.402 1.934a1.119 1.119 0 00-.215.047C3.008 8.62 1.71 9.269.926 10.015c-.465.442-.77.938-.883 1.481-.113.578 0 1.156.312 1.7.516.894 1.465 1.597 2.817 2.155.543.223 1.156.426 1.844.61a1.023 1.023 0 00-.07.226c-.391 1.891-.477 3.344-.223 4.395.148.629.425 1.14.84 1.508.44.39 1 .582 1.625.582 1.035 0 2.12-.473 3.28-1.364.477-.37.973-.816 1.489-1.336a1.2 1.2 0 00.195.227c1.446 1.285 2.66 2.082 3.7 2.39.617.184 1.195.2 1.722.024.559-.187 1.004-.574 1.317-1.117.515-.894.652-2.074.46-3.527a14.941 14.941 0 00-.425-2.012 1.225 1.225 0 00.238-.047c1.828-.61 3.125-1.258 3.91-2.004.465-.441.77-.937.883-1.48.113-.578 0-1.157-.313-1.7-.515-.894-1.464-1.597-2.816-2.156a14.576 14.576 0 00-1.906-.625.865.865 0 00.059-.195z" />
    </svg>
  );
}

export function ReactIcon(props: PropTypes) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <path d="M12 10.11c1.03 0 1.87.84 1.87 1.89 0 1-.84 1.85-1.87 1.85-1.03 0-1.87-.85-1.87-1.85 0-1.05.84-1.89 1.87-1.89M7.37 20c.63.38 2.01-.2 3.6-1.7-.52-.59-1.03-1.23-1.51-1.9a22.7 22.7 0 01-2.4-.36c-.51 2.14-.32 3.61.31 3.96m.71-5.74l-.29-.51c-.11.29-.22.58-.29.86.27.06.57.11.88.16l-.3-.51m6.54-.76l.81-1.5-.81-1.5c-.3-.53-.62-1-.91-1.47C13.17 9 12.6 9 12 9c-.6 0-1.17 0-1.71.03-.29.47-.61.94-.91 1.47L8.57 12l.81 1.5c.3.53.62 1 .91 1.47.54.03 1.11.03 1.71.03.6 0 1.17 0 1.71-.03.29-.47.61-.94.91-1.47M12 6.78c-.19.22-.39.45-.59.72h1.18c-.2-.27-.4-.5-.59-.72m0 10.44c.19-.22.39-.45.59-.72h-1.18c.2.27.4.5.59.72M16.62 4c-.62-.38-2 .2-3.59 1.7.52.59 1.03 1.23 1.51 1.9.82.08 1.63.2 2.4.36.51-2.14.32-3.61-.32-3.96m-.7 5.74l.29.51c.11-.29.22-.58.29-.86-.27-.06-.57-.11-.88-.16l.3.51m1.45-7.05c1.47.84 1.63 3.05 1.01 5.63 2.54.75 4.37 1.99 4.37 3.68 0 1.69-1.83 2.93-4.37 3.68.62 2.58.46 4.79-1.01 5.63-1.46.84-3.45-.12-5.37-1.95-1.92 1.83-3.91 2.79-5.38 1.95-1.46-.84-1.62-3.05-1-5.63-2.54-.75-4.37-1.99-4.37-3.68 0-1.69 1.83-2.93 4.37-3.68-.62-2.58-.46-4.79 1-5.63 1.47-.84 3.46.12 5.38 1.95 1.92-1.83 3.91-2.79 5.37-1.95M17.08 12c.34.75.64 1.5.89 2.26 2.1-.63 3.28-1.53 3.28-2.26 0-.73-1.18-1.63-3.28-2.26-.25.76-.55 1.51-.89 2.26M6.92 12c-.34-.75-.64-1.5-.89-2.26-2.1.63-3.28 1.53-3.28 2.26 0 .73 1.18 1.63 3.28 2.26.25-.76.55-1.51.89-2.26m9 2.26l-.3.51c.31-.05.61-.1.88-.16-.07-.28-.18-.57-.29-.86l-.29.51m-2.89 4.04c1.59 1.5 2.97 2.08 3.59 1.7.64-.35.83-1.82.32-3.96-.77.16-1.58.28-2.4.36-.48.67-.99 1.31-1.51 1.9M8.08 9.74l.3-.51c-.31.05-.61.1-.88.16.07.28.18.57.29.86l.29-.51m2.89-4.04C9.38 4.2 8 3.62 7.37 4c-.63.35-.82 1.82-.31 3.96a22.7 22.7 0 012.4-.36c.48-.67.99-1.31 1.51-1.9z" />
    </svg>
  );
}

export function CPP(props: PropTypes) {
  return (
    <svg
      fill="#000000"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
      version="1.1"
      id="Capa_1"
      viewBox="0 0 312.553 312.553"
    >
      <path
        d="M302.553,0H10C4.477,0,0,4.478,0,10v292.553c0,5.522,4.477,10,10,10h292.553c5.523,0,10-4.478,10-10V10
	C312.553,4.478,308.076,0,302.553,0z M122.031,193.288c-9.481,8.296-21.592,12.865-34.102,12.865
	c-28.108,0-50.976-22.4-50.976-49.934c0-27.47,22.868-49.818,50.976-49.818c12.527,0,24.597,4.53,33.987,12.756
	c3.874,3.392,4.263,9.283,0.87,13.156c-3.393,3.874-9.283,4.263-13.157,0.869c-5.988-5.245-13.695-8.135-21.7-8.135
	c-17.827,0-32.33,13.983-32.33,31.172c0,17.251,14.503,31.286,32.33,31.286c7.992,0,15.742-2.931,21.822-8.251
	c3.875-3.393,9.765-2.998,13.156,0.877C126.298,184.007,125.906,189.898,122.031,193.288z M185.951,165.6h-18.789v18.79
	c0,5.149-4.174,9.323-9.324,9.323s-9.324-4.174-9.324-9.323V165.6h-18.788c-5.149,0-9.324-4.174-9.324-9.323
	s4.174-9.323,9.324-9.323h18.788v-18.789c0-5.149,4.174-9.323,9.324-9.323s9.324,4.174,9.324,9.323v18.789h18.789
	c5.149,0,9.324,4.174,9.324,9.323S191.101,165.6,185.951,165.6z M266.276,165.6h-18.789v18.79c0,5.149-4.174,9.323-9.324,9.323
	c-5.149,0-9.324-4.174-9.324-9.323V165.6h-18.788c-5.149,0-9.324-4.174-9.324-9.323s4.174-9.323,9.324-9.323h18.788v-18.789
	c0-5.149,4.174-9.323,9.324-9.323c5.149,0,9.324,4.174,9.324,9.323v18.789h18.789c5.149,0,9.324,4.174,9.324,9.323
	S271.426,165.6,266.276,165.6z"
      />
    </svg>
  );
}

export function Javascript(props: PropTypes) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <path
          d="M392.4,471.86c-44.67,0-73.55-21.3-87.63-49.15l39.17-22.69c10.32,16.85,23.71,29.21,47.44,29.21
          c19.92,0,32.64-9.96,32.64-23.71c0-20.67-27.6-28.77-47.08-37.11c-34.71-14.77-57.75-33.34-57.75-72.52
          c0-36.08,27.49-63.56,70.48-63.56c30.57,0,52.58,10.65,68.38,38.47l-37.45,24.06c-8.24-14.77-17.18-20.61-30.92-20.61
          c-14.11,0-23.04,8.94-23.04,20.61c0,14.44,8.93,20.28,29.57,29.21c43.24,18.52,75.95,33.1,75.95,80.76
          C472.14,448.15,438.12,471.86,392.4,471.86z M281.6,399.34c0,49.84-30.69,76.19-73.32,76.19c-38.5,0-61.57-14.73-72.91-40.32h-0.38
          h-0.18h-0.1l39.14-27.36c7.55,13.39,14.36,22.89,30.85,22.89c15.82,0,25.7-8.01,25.7-32.05V230.4h51.2V399.34z M0,512h512V0H0V512z
          "
        />
      </g>
    </svg>
  );
}

export function Instagram(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <path d="M12,2.162c3.204,0,3.584,0.012,4.849,0.07c1.308,0.06,2.655,0.358,3.608,1.311c0.962,0.962,1.251,2.296,1.311,3.608   c0.058,1.265,0.07,1.645,0.07,4.849c0,3.204-0.012,3.584-0.07,4.849c-0.059,1.301-0.364,2.661-1.311,3.608   c-0.962,0.962-2.295,1.251-3.608,1.311c-1.265,0.058-1.645,0.07-4.849,0.07s-3.584-0.012-4.849-0.07   c-1.291-0.059-2.669-0.371-3.608-1.311c-0.957-0.957-1.251-2.304-1.311-3.608c-0.058-1.265-0.07-1.645-0.07-4.849   c0-3.204,0.012-3.584,0.07-4.849c0.059-1.296,0.367-2.664,1.311-3.608c0.96-0.96,2.299-1.251,3.608-1.311   C8.416,2.174,8.796,2.162,12,2.162 M12,0C8.741,0,8.332,0.014,7.052,0.072C5.197,0.157,3.355,0.673,2.014,2.014   C0.668,3.36,0.157,5.198,0.072,7.052C0.014,8.332,0,8.741,0,12c0,3.259,0.014,3.668,0.072,4.948c0.085,1.853,0.603,3.7,1.942,5.038   c1.345,1.345,3.186,1.857,5.038,1.942C8.332,23.986,8.741,24,12,24c3.259,0,3.668-0.014,4.948-0.072   c1.854-0.085,3.698-0.602,5.038-1.942c1.347-1.347,1.857-3.184,1.942-5.038C23.986,15.668,24,15.259,24,12   c0-3.259-0.014-3.668-0.072-4.948c-0.085-1.855-0.602-3.698-1.942-5.038c-1.343-1.343-3.189-1.858-5.038-1.942   C15.668,0.014,15.259,0,12,0z" />
        <path d="M12,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.162,6.162,6.162s6.162-2.759,6.162-6.162   C18.162,8.597,15.403,5.838,12,5.838z M12,16c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S14.209,16,12,16z" />
        <circle cx="18.406" cy="5.594" r="1.44" />
      </g>
    </svg>
  );
}

export function CSS(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={`${props.width}`}
      height={props.height ? props.height : "auto"}
    >
      <polygon points="6.972,14.935 7.274,18.316 11.994,19.59 11.998,19.589 11.998,19.589 16.725,18.313 17.217,12.816 2.528,12.816   2.149,8.578 17.584,8.578 17.97,4.238 1.771,4.238 1.385,0 22.615,0 20.686,21.59 12.013,23.994 12.013,23.995 11.993,24   3.312,21.59 2.718,14.935 " />
    </svg>
  );
}

export function HTML(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={props.width}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <path d="M5.081,0h1.078v1.069h0.994V0h1.078v3.234H7.153V2.156H6.169v1.078H5.081L5.081,0z M9.656,1.078H8.705V0h2.986v1.078   h-0.956v2.156H9.656V1.078z M12.164,0h1.13l0.694,1.139L14.681,0h1.13v3.234h-1.078V1.631l-0.755,1.162l-0.755-1.162v1.603h-1.059   V0z M16.345,0h1.078v2.166h1.528v1.069h-2.606V0z" />
        <path d="M3.497,4.716l1.547,17.362L11.986,24l6.97-1.931l1.547-17.353H3.497z M6.656,8.264h5.334v2.128h-3l0.197,2.18h2.803v2.123   H7.237L6.656,8.264z M12,14.7h2.616l-0.248,2.766L12,18.101V14.7z M17.625,20.953L12,22.523v-2.198l-4.369-1.219l-0.3-3.342h2.138   l0.15,1.702l2.377,0.636l-0.005,0.001v2.212L12,20.313l4.35-1.207l0.586-6.534H12v-2.18h5.128l0.197-2.128H12V6.141h6.952   L17.625,20.953z" />
        <polygon points="12,12.572 16.936,12.572 16.35,19.106 12,20.313 12,18.101 14.367,17.466 14.616,14.7 12,14.7  " />
        <polygon points="17.325,8.264 17.128,10.392 12,10.392 12,8.264  " />
        <path d="M11.991,8.264v2.128H12V8.264H11.991z M11.991,12.572v2.123H12v-2.123H11.991z M11.995,18.102l-0.005,0.001v2.212   L12,20.313v-2.21L11.995,18.102z" />
        <path d="M11.991,8.264v2.128h5.137l0.197-2.128H11.991z M11.991,12.572V14.7h2.625l-0.248,2.766L12,18.101l-0.005,0.001   l-0.005,0.001v2.212L12,20.313l4.35-1.207l0.586-6.534H11.991z" />
      </g>
    </svg>
  );
}

export function JAVA(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={props.width}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <path d="M5.566,14.276c0-0.664,2.521-1.037,3.694-1.128l0.112,0.065c-0.451,0.082-2.26,0.401-2.26,0.817   c0,0.453,2.775,0.75,4.385,0.75c2.735,0,4.595-0.414,5.095-0.55l0.7,0.407c-0.479,0.235-2.536,0.849-5.795,0.849   C7.876,15.486,5.566,14.778,5.566,14.276L5.566,14.276z M11.085,23.604c-1.433,0.012-3.183-0.106-4.655-0.353l-0.137,0.078   c1.467,0.43,3.509,0.69,5.752,0.67c4.406-0.038,7.978-1.131,8.048-2.446l-0.051-0.03C19.747,21.884,17.842,23.545,11.085,23.604   L11.085,23.604z M11.46,22.757c3.606-0.032,7.641-0.737,7.63-1.923c-0.002-0.215-0.142-0.363-0.264-0.451l-0.059,0.034   c-0.333,0.919-3.15,1.598-7.313,1.634c-2.686,0.024-6.406-0.62-6.413-1.363c-0.006-0.746,1.763-1.155,1.763-1.155L6.679,19.46   c-1.185,0.163-3.37,0.731-3.363,1.551C3.326,22.196,8.346,22.784,11.46,22.757L11.46,22.757z M19.584,14.593   c-0.073,1.391-1.358,2.258-2.643,2.989l0.116,0.067c1.371-0.386,3.817-1.509,3.615-3.235c-0.101-0.86-0.888-1.476-1.913-1.476   c-0.32,0-0.604,0.056-0.834,0.126l-0.001,0.002l-0.049,0.122C18.793,13.011,19.631,13.681,19.584,14.593L19.584,14.593z    M8.991,18.727c-0.418,0.083-1.33,0.293-1.33,0.736c0,0.614,1.951,1.085,3.835,1.085c2.592,0,3.654-0.667,3.702-0.702l-1.078-0.624   c-0.458,0.109-1.231,0.28-2.621,0.28c-1.552,0-2.563-0.265-2.563-0.556c0-0.062,0.039-0.135,0.11-0.189L8.991,18.727z    M15.359,16.656C14.763,16.825,13.42,17.1,11.5,17.1c-1.884,0-3.424-0.322-3.429-0.702c-0.004-0.253,0.302-0.363,0.302-0.363   l-0.054-0.031c-0.903,0.159-1.741,0.406-1.736,0.775c0.008,0.67,2.57,1.172,4.913,1.172c1.992,0,3.905-0.334,4.768-0.772   L15.359,16.656z" />
        <path d="M14.845,1.717c0,3.693-5.06,5.106-5.06,7.731c0,1.843,1.222,2.999,1.899,3.73l-0.055,0.032   c-0.854-0.534-3.1-1.876-3.1-4.093c0-3.112,5.813-4.599,5.813-8.134c0-0.435-0.064-0.769-0.11-0.948L14.29,0   C14.474,0.231,14.845,0.81,14.845,1.717L14.845,1.717z M16.509,4.987l-0.061-0.035c-1.101,0.369-4.491,1.707-4.491,4.202   c0,1.411,1.378,2.193,1.378,3.516c0,0.472-0.267,0.915-0.483,1.179l0.109,0.063c0.574-0.373,1.589-1.18,1.589-2.222   c0-0.883-1.221-1.943-1.221-3.078C13.328,6.825,15.685,5.423,16.509,4.987L16.509,4.987z" />
      </g>
    </svg>
  );
}

export function Python(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={props.width}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <g id="g2303_00000031922597863478397790000004595394903733610625_">
          <path
            id="path1948_00000134962089881649523420000009399677824023126944_"
            d="M11.859,0C10.88,0.005,9.945,0.088,9.123,0.234    C6.7,0.662,6.26,1.558,6.26,3.21v2.182h5.726V6.12H6.26H4.111c-1.664,0-3.121,1-3.577,2.903c-0.526,2.181-0.549,3.542,0,5.819    c0.407,1.695,1.379,2.903,3.043,2.903h1.969v-2.616c0-1.89,1.635-3.557,3.577-3.557h5.719c1.592,0,2.863-1.311,2.863-2.91V3.21    c0-1.552-1.309-2.717-2.863-2.976C13.858,0.07,12.837-0.004,11.859,0z M8.762,1.755c0.591,0,1.074,0.491,1.074,1.094    c0,0.601-0.483,1.088-1.074,1.088c-0.594,0-1.074-0.486-1.074-1.088C7.688,2.246,8.169,1.755,8.762,1.755z"
          />
          <path
            id="path1950_00000083807539188134144630000011128538031068007323_"
            d="M18.418,6.12v2.543c0,1.971-1.671,3.63-3.577,3.63    H9.123c-1.567,0-2.863,1.341-2.863,2.91v5.452c0,1.552,1.349,2.464,2.863,2.91c1.812,0.533,3.55,0.629,5.719,0    c1.441-0.417,2.863-1.257,2.863-2.91v-2.182h-5.719v-0.727h5.719h2.863c1.664,0,2.284-1.161,2.863-2.903    c0.598-1.794,0.572-3.518,0-5.819c-0.411-1.657-1.197-2.903-2.863-2.903H18.418z M15.202,19.927c0.594,0,1.074,0.486,1.074,1.088    c0,0.604-0.481,1.094-1.074,1.094c-0.591,0-1.074-0.491-1.074-1.094C14.128,20.413,14.611,19.927,15.202,19.927z"
          />
        </g>
      </g>
    </svg>
  );
}

export function Typescript(props: PropTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={props.width}
      height={props.height ? props.height : "auto"}
    >
      <g>
        <path d="M21.656,0H2.344C1.05,0,0,1.05,0,2.344v19.312C0,22.95,1.05,24,2.344,24h19.312C22.95,24,24,22.95,24,21.656V2.344   C24,1.05,22.95,0,21.656,0z M13.922,13.316h-3.01v8.574H8.527v-8.574H5.531v-1.926h8.391V13.316z M21.698,20.37   c-0.467,0.835-1.325,1.305-2.238,1.5c-1.06,0.226-2.187,0.214-3.25,0.015c-0.521-0.098-0.972-0.244-1.353-0.44v-2.347   c0.426,0.357,0.888,0.625,1.387,0.803c0.499,0.179,1.003,0.268,1.511,0.268c0.45,0,0.951-0.056,1.339-0.304   c0.266-0.17,0.444-0.438,0.444-0.759c0-0.437-0.316-0.767-0.657-0.997c-0.499-0.336-1.072-0.555-1.625-0.785   c-0.822-0.342-1.434-0.76-1.838-1.254c-0.702-0.859-0.817-2.231-0.275-3.201c0.463-0.828,1.316-1.316,2.216-1.533   c0.981-0.236,2.046-0.236,3.041-0.081c0.423,0.066,0.813,0.167,1.17,0.304v2.193c-0.176-0.122-0.368-0.23-0.576-0.322   c-0.41-0.183-0.853-0.307-1.298-0.367c-0.445-0.06-0.914-0.07-1.353,0.033c-0.346,0.08-0.71,0.241-0.91,0.55   c-0.083,0.13-0.125,0.275-0.125,0.436c0,0.176,0.046,0.334,0.139,0.473c0.235,0.353,0.649,0.58,1.02,0.763   c0.652,0.32,1.336,0.56,1.962,0.931c0.608,0.359,1.148,0.859,1.412,1.525c0.127,0.32,0.191,0.693,0.191,1.118   C22.031,19.479,21.92,19.972,21.698,20.37z" />
      </g>
    </svg>
  );
}
